/* <ss-announcements> (CORE, header group). Manual prev/next under 1024px, never auto-rotates (WCAG 2.2.2).
   The server already renders .is-eligible/.is-current for the first message, so nothing shifts before this runs. */
(() => {
  if (customElements.get('ss-announcements')) return;
  const S = (window.Sunsnub = window.Sunsnub || {}), d = document;

  class Announcements extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-announce-item]')];
      this.mq = matchMedia('(min-width: 1024px)');
      this.btns = [this.querySelector('[data-announce-prev]'), this.querySelector('[data-announce-next]')];
      this.btns.forEach((b, i) => b && b.addEventListener('click', () => this.step(i ? 1 : -1)));
      this.sync = () => this.render();
      d.addEventListener('datewindows:applied', this.sync);
      this.mq.addEventListener('change', this.sync);
      this.render();
    }
    disconnectedCallback() { d.removeEventListener('datewindows:applied', this.sync); this.mq.removeEventListener('change', this.sync); }
    eligible() {
      const c = (S.settings || {}).country;
      return this.items.filter((el) => {
        const k = el.dataset.country;
        if (el.classList.contains('announce__item--xmas')) el.hidden = !el.querySelector('.xmas:not([hidden])');
        return !el.hidden && (!k || k === 'all' || k === c) && (this.mq.matches || !el.hasAttribute('data-desktop-only'));
      });
    }
    render(target) {
      const l = this.eligible(), bar = this.closest('.announce');
      const cur = (this.current = l.includes(target || this.current) ? target || this.current : l[0]);
      this.items.forEach((el) => { el.classList.toggle('is-current', el === cur); el.classList.toggle('is-eligible', l.includes(el)); });
      this.btns.forEach((b) => b && (b.hidden = this.mq.matches || l.length < 2));
      if (bar) bar.hidden = !l.length;
    }
    step(n) { const l = this.eligible(); if (l.length) this.render(l[(l.indexOf(this.current) + n + l.length) % l.length]); }
  }
  customElements.define('ss-announcements', Announcements);

  d.addEventListener('shopify:block:select', (e) => {
    const bar = e.target.closest && e.target.closest('ss-announcements');
    if (bar) bar.render(e.target.closest('[data-announce-item]'));
  });
})();
